import { useGestock } from "./GestockContext";
import { formatMonthLabel } from "./monthUtils";

/**
 * Sélecteur de mois global — filtre toutes les tables d'historique
 * (Commandes, Journal, Libre Pratique, Douane, Stations) sur un même mois.
 */
export default function MonthSelector() {
  const { selectedMonth, goToPrevMonth, goToNextMonth, isCurrentMonth } = useGestock();

  return (
    <div className="selector-bar" style={{ borderTop: "none" }}>
      <button
        type="button"
        className="month-nav-btn"
        onClick={goToPrevMonth}
        aria-label="Mois précédent"
      >
        ◀
      </button>
      <div className="month-label">🗓 {formatMonthLabel(selectedMonth)}</div>
      <button
        type="button"
        className="month-nav-btn"
        onClick={goToNextMonth}
        disabled={isCurrentMonth}
        aria-label="Mois suivant"
      >
        ▶
      </button>
    </div>
  );
}
